var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.9999C0 9.40817 0.479694 8.92847 1.07143 8.92847H18.9286C19.5203 8.92847 20 9.40817 20 9.9999C20 10.5916 19.5203 11.0713 18.9286 11.0713H1.07143C0.479694 11.0713 0 10.5916 0 9.9999Z",
    fill: "#65C3E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14286 2.5C2.14286 2.30276 2.30276 2.14286 2.5 2.14286H5C5.59173 2.14286 6.07143 1.66316 6.07143 1.07143C6.07143 0.479694 5.59173 0 5 0H2.5C1.11929 0 0 1.11929 0 2.5V5C0 5.59173 0.479694 6.07143 1.07143 6.07143C1.66316 6.07143 2.14286 5.59173 2.14286 5V2.5ZM15 0C14.4083 0 13.9286 0.479694 13.9286 1.07143C13.9286 1.66316 14.4083 2.14286 15 2.14286H17.5C17.6973 2.14286 17.8571 2.30276 17.8571 2.5V5C17.8571 5.59173 18.3369 6.07143 18.9286 6.07143C19.5203 6.07143 20 5.59173 20 5V2.5C20 1.11929 18.8807 0 17.5 0H15ZM18.9286 13.9286C19.5203 13.9286 20 14.4083 20 15V17.5C20 18.8807 18.8807 20 17.5 20H15C14.4083 20 13.9286 19.5203 13.9286 18.9286C13.9286 18.3369 14.4083 17.8571 15 17.8571H17.5C17.6973 17.8571 17.8571 17.6973 17.8571 17.5V15C17.8571 14.4083 18.3369 13.9286 18.9286 13.9286ZM2.14303 15C2.14303 14.4083 1.66334 13.9286 1.0716 13.9286C0.47987 13.9286 0.000174386 14.4083 0.000174386 15V17.4999C0.000174386 18.8806 1.11946 19.9999 2.50017 19.9999H5C5.59173 19.9999 6.07143 19.5201 6.07143 18.9284C6.07143 18.3367 5.59173 17.857 5 17.857H2.50017C2.30293 17.857 2.14303 17.6971 2.14303 17.4999V15Z",
    fill: "#ABDEF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCardIcon);
export default __webpack_public_path__ + "static/media/addCardIcon.bd79d4c599e792ecfb3a5fc3c0c10324.svg";
export { ForwardRef as ReactComponent };